import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-ZTCX702B75";
const GA_IDSDTI = "G-4F57ZZSN3E";

function Analytics() {

    const location = useLocation();

    useEffect(() => {

        if (window.gtag) {

            window.gtag("config", GA_ID, {
                page_path: location.pathname + location.search,
            });
            window.gtag("config", GA_IDSDTI, {
                page_path: location.pathname + location.search,
            });

        }

    }, [location]);

    return null;
}

export default Analytics;